import React, { useEffect, useState, useRef} from "react";
import "./style.css";

import api, { MENSAGEM_ERRO_HTTP } from "../../services/api";
import LikerSatisfacao from "../../components/LikertSatisfacao";
import LikerNota from "../../components/LikertNota";
import Avaliacao from "../../components/Avaliacao";
import SimNao from "../../components/SimNao";
import { useForm } from "react-hook-form";
import Loading from "../../components/Loading";
import { confirmacao, getParam, mensagemErro, replaceAll } from "../../library";
import { MdOutlineError, MdCheckCircle } from "react-icons/md";
import Page404 from "../404";

export const COR_DEFAULT = "#11c4e0";

export const CampoObrigatorio = ( { id } ) => {
    return (
        <div id={id} className="" style={{display: "none"}}>
            <div className="pesquisa-satisfacao-validacao">
                <MdOutlineError size={26} color="tomato"/>
                <span className="pesquisa-satisfacao-validacao-text">Campo é necessário</span>
            </div>
        </div>
    )
}

export async function handleValidaCampos(campoList, campo) {
    let validou = true;
    let component;
    let componentObservacao;
    let focou = false;
    let focaObrigatorioNota = false;

    if (campo) {
        component = `div_${campo?.codperguntaSatisfacao}`;
        if (campo?.tipoResposta === "LIKERT_PROBABILIDADE" || campo?.tipoResposta === "LIKERT_SATISFACAO")  
            component += "_satisfacao";

        component = document.getElementById(component);
        
        if (component) {
            component.style.display = "none";
        }        
    } else {
        for (const item in campoList) {
            component = replaceAll(item, "id_", "div_");
            component = document.getElementById(component);
            
            if (component) {
                if (item.indexOf("_satisfacao") > 0) {
                    componentObservacao = document.getElementById("id_observacao");
                    if (componentObservacao?.value === "" && (campoList[item] === "" || (campoList[item] >= 0 && campoList[item] <= 3))) 
                        focaObrigatorioNota = true;
                }

                if (campoList[item] === "" || campoList[item] < 0) {                   
                    validou = false;
                    component.style.display = "block";

                    if (! focou) {
                        focou = true;
                        component?.scrollIntoView({ behavior: "smooth" });
                    }                      
                } else
                    component.style.display = "none";                  
            }
        } 

        component = document.getElementById("div_obrigatorio_comentario");

        if (component) {
            if (focaObrigatorioNota) {
                validou = false;
                component.style.display = "block";

                if (! focou) 
                    component.scrollIntoView({ behavior: "smooth" });
            } else {
                component.style.display = "none";
            }
        }
    }

    return validou;
}

const PesquisaJaEnviada = ( { text } ) => {
    return (
        <div className="pesquisa-satisfacao-ja-enviada-container">
            <MdOutlineError size={48} color="tomato"/>
            <span className="pesquisa-satisfacao-ja-enviada">{text}</span>
        </div>
    )
}

const PesquisaEnviada = ( { text } ) => {
    return (
        <div className="pesquisa-satisfacao-ja-enviada-container">
            <MdCheckCircle size={48} color="green"/>
            <span className="pesquisa-satisfacao-ja-enviada">{text}</span>
        </div>
    )
}

const PesquisaSatisfacao = () => {
    const [loading, setLoading] = useState(true);
    const [logo, setLogo] = useState(null);
    const [data, setData] = useState([]);
    const [validouAutenticacao, setValidouAutenticacao] = useState(false);
    const [jaEnviada, setJaEnviada] = useState(false);
    const [jaEnviadaTexto, setJaEnviadaTexto] = useState("");
    const [enviada, setEnviada] = useState(false);
    const [enviadaTexto, setEnviadaTexto] = useState("");
    const { register, handleSubmit, getValues, setValue } = useForm();
    const pageRef = useRef(null);

    async function handleGet() {
        setLoading(true);

        const hash = getParam("hash");
        const id = getParam("id");

        try {
            const response = await (await api.get(
                `/site-atendimento/pesquisa-satisfacao?id=${id}&hash=${hash}`
            )).data;

            if (response?.jaEnviada) {
                setJaEnviada(true);
                setJaEnviadaTexto(response.message);
                setValidouAutenticacao(true);
            } else if (response?.error) {
                mensagemErro(response.message, "", null, null);
            } else {
                setData(response.list);
                setValidouAutenticacao(true);

                if (response?.logo)
                    setLogo(response.logo);
            }           
        } catch {
            MENSAGEM_ERRO_HTTP();
        } finally {
            setLoading(false);
        }     
    }

    async function handlePost() {
        const validou = await handleValidaCampos(getValues());
        if (! validou) {
            return false;
        }

        confirmacao("Confirma o envio?", async () => {
            let payload = getValues();
            payload["id"] = getParam("id");
            payload["hash"] = getParam("hash");
            payload["id_observacao"] = replaceAll(payload["id_observacao"], "\n", "#QUEBRA_LINHA#") 
    
            setLoading(true);
    
            try {
                const response = await (await api.post(
                    "/site-atendimento/pesquisa-satisfacao", 
                    JSON.stringify(payload),
                    {
                        headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    }}                
                    )).data;   
                    
                    if (response?.error) {
                        mensagemErro(response.message, "", null, () => {});
                    } else {
                        setEnviada(true);
                        setEnviadaTexto(response.message);
                    }
            } catch {
                MENSAGEM_ERRO_HTTP(null, () => {});
            } finally {
                setLoading(false);
            }                  
        },
        null);
    }

    useEffect(() => {
        document.title = "Pesquisa de satisfação";
        handleGet();
    }, []);

    if (! validouAutenticacao && loading)
        return <div className="pesquisa-satisfacao-container"><Loading /></div>

    if (! validouAutenticacao)
        return <Page404 />

    if (jaEnviada)
        return <PesquisaJaEnviada text={jaEnviadaTexto}/>
       
    if (enviada)
        return <PesquisaEnviada text={enviadaTexto}/>

    return (
        <>
            {loading &&
            <div style={{display: "flex", height: "100vh"}}>
                <Loading text={"Aguarde..."}/>
            </div>
            }

            <div className="pesquisa-satisfacao-container">
                <div className="pesquisa-satisfacao-content" ref={pageRef}>
                    <div className="pesquisa-satisfacao-container-logo">
                        {logo && <img alt="logo" src={`data:image/png;base64,${logo}`} className="pesquisa-satisfacao-logo" />}
                    </div>

                    <span style={{fontSize: 14}}>Queremos saber o que achou do nosso atendimento! Compartilhe sua experiência no Centroeco, respondendo nossa rápida pesquisa.</span>

                    <form id="form-pesquisa-satisfacao" className="pesquisa-satisfacao-item" action="." onSubmit={e => { e.preventDefault(); }}>
                        {data?.map((item) => {
                            switch (item?.tipoResposta) {
                                case "LIKERT_SATISFACAO": {
                                    return <LikerSatisfacao item={item} register={register} setValue={setValue} getValues={getValues}/>
                                    break;
                                }
                                case "LIKERT_PROBABILIDADE": {
                                    return <LikerSatisfacao item={item} register={register} setValue={setValue} getValues={getValues}/>
                                    break;
                                } 
                                case "NOTA_0_10": {
                                    return <LikerNota item={item} register={register} setValue={setValue} getValues={getValues}/>
                                    break;
                                }      
                                case "SIM_NAO": {
                                    return <SimNao item={item} register={register} setValue={setValue} getValues={getValues}/>
                                    break;
                                }                                                                                       
                            }
                        })}

                        <Avaliacao register={register} setValue={setValue} />
                    </form>

                    <div className="pesquisa-satisfacao-bottom-container">
                        {! loading && <button type="text" className="pesquisa-satisfacao-enviar" onClick={handleSubmit(handlePost)}>Enviar</button>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PesquisaSatisfacao;